<template>
  <div class="page_backgroundCheckRecord">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <!-- <div class="screenInputs">
          <div class="screenInput checktime">
            <div class="flname">查询时间:</div>
            <el-date-picker v-model="listQuery.time" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div> -->
      </div>
      <!-- <div class="top-right">
        <el-button v-if="showDropScreen==-1" type="success" size="small" style="margin-right:10px">搜索</el-button>
        <el-button type="success" size="small" style="margin-right:24px">导出数据</el-button>
      </div> -->
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工作台</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <div class="dashboard">
        <div class="dashboard_item" style="margin-right: 15px;">
            <div class="dashboard_item_title">待授权 <span class="dashboard_item_content">80</span> </div>
          </div>
          <div class="dashboard_item">
            <div class="dashboard_item_title">已出报告 <span class="dashboard_item_content">20</span> </div>
          </div>
      </div> -->
      <div class="dashboard">
        <div class="dashboard_item">
          <div class="dashboard_item_title">待授权 </div>
          <div class="dashboard_item_content">5</div>
        </div>
        <div class="dashboard_item">
          <div class="dashboard_item_title">已出报告 </div>
          <div class="dashboard_item_content">5</div>
        </div>
        <div class="dashboard_item">
          <div class="dashboard_item_title">余额 </div>
          <div class="dashboard_item_content">￥ 1000</div>
          <div class="recharge cp recharge2">充值</div>
        </div>
        <div class="dashboard_item" style="margin-right: 0;">
          <div class="dashboard_item_title">消费金额 </div>
          <div class="dashboard_item_content">￥500</div>
        </div>
      </div>
      <div class="ftabs">
        <!-- <div class="property">
          <div class="property_title">账户信息</div>
          <div class="flex">
            <div class="balanceBox">
              <div class="balance_title">余额</div>
              <div class="flex">
                <div class="balance">￥0.00</div>
                <div class="recharge cp">充值</div>
              </div>
            </div>
            <div class="balanceBox">
              <div class="balance_title">消费金额</div>
              <div class="flex">
                <div class="balance">￥60.00</div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="title2">账户明细</div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label=" 全  部 " name="first"></el-tab-pane>
          <el-tab-pane label=" 充  值 " name="second"></el-tab-pane>
          <el-tab-pane label=" 消  费 " name="third"></el-tab-pane>
          <el-tab-pane label=" 调  整 " name="fourth"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" style="width: 99%" border>
          <el-table-column prop="date" label="交易时间">
          </el-table-column>
          <el-table-column prop="jg" label="客户机构" width="200px">
          </el-table-column>
          <el-table-column prop="ls" label="流水号" width="200px">
          </el-table-column>
          <el-table-column prop="lx" label="交易类型">
          </el-table-column>
          <el-table-column prop="je" label="金额">
          </el-table-column>
          <el-table-column prop="ye" label="余额">
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              {{scope.row.bz}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      showDropScreen: -1,
      listQuery: {
        time: "",
        cxry: "",
        cxnr: "",
        cxjg: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableData: [
        {
          date: "2023-05-15 13:25:14",
          jg: "宁波杰博人力资源有限公司",
          ls: "2305151358143156",
          lx: "闪查消费",
          je: "-15",
          ye: 1080,
          bz: "张三",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    handleClick() {},
  },
};
</script>
<style scoped>
.flname {
  min-width: 40px;
  width: 66px;
  padding-right: 8px;
}

.r_dropDownScreen {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
}

.re_down_form .el-form-item {
  margin-bottom: 3px;
  margin-right: 0;
}
.ftabs {
  background: #fff;
  padding: 10px 0 16px 23px;
  width: 98%;
  margin-bottom: 16px;
}
.recharge {
  font-size: 14px;
  color: #f59a23;
  line-height: 32px;
}
.recharge2{
  position: absolute;
  right: 26px;
  bottom: 14px;
}
.property {
  padding-top: 15px;
}
.property_title {
  border-bottom: 1px solid #e1e1e1;
  padding-bottom: 12px;
  color: #333;
  font-size: 16px;
  line-height: 30px;
  font-weight: bold;
}
.balanceBox {
  margin-top: 20px;
  margin-right: 150px;
}
.balance_title {
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
}
.balance {
  font-weight: bold;
  color: #333;
  font-size: 20px;
  padding-right: 20px;
}
.title2{
  color: #333;
  font-size: 16px;
  line-height: 30px;
  font-weight: bold;
  margin-top: 20px;
}
/* .dashboard {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  width: calc(98% + 33px);
}
.dashboard_item {
  width: 49%;
  background: #fff;
  position: relative;
}
.dashboard_item_title {
  font-size: 20px;
  text-align: center;
  padding: 16px 0;
}
.dashboard_item_content {
  font-size: 28px;
  font-weight: bold;
  margin-left: 30px;
} */
.dashboard {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.dashboard_item {
  width: calc(25% - 52px);
  margin-right: 15px;
  background: #fff;
  padding: 0 20px;
  position: relative;
}
.dashboard_item_title {
  font-size: 16px;
  text-align: center;
  padding: 16px 0;
  border-bottom: 1px dashed #c3c3c3;
}
.dashboard_item_content {
  text-align: center;
  font-size: 28px;
  padding: 16px 0;
}
</style>
<style>
.page_backgroundCheckRecord .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 230px !important;
  height: 32px;
  line-height: 32px;
}
.checktime .el-date-editor .el-range__icon {
  height: 32px !important;
}
</style>